export const ROUTES = {
  clinicalCodeTransformations: {
    parentPath: "admin",
    slug: "clinical-code-transformations",
    route: "/admin/clinical-code-transformations",
  },
};
